import React, {Component}  from 'react';
import {connect} from 'react-redux';
import {login} from '../../data/user/actions';
import {isLoadingUser} from "../../reducer";
import {getTranslate} from 'react-localize-redux';

import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'

class LoginForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            loading: false
        };

    }


    handleEmailChange(e) {
        this.setState({email: e.target.value});
    }

    handlePasswordChange(e) {
        this.setState({password: e.target.value});
    }

    handleLogin(event){
        this.props.login(this.state.email,this.state.password);
    }

    render(){
        return(<div className='login-form' style={{height: '100%'}}>
                {/*
      Heads up! The styles below are necessary for the correct render of this example.
      You can do same with CSS, the main idea is that all the elements up to the `Grid`
      below must have a height of 100%.
    */}
                <style>{`
      body > div,
      body > div > div,
      body > div > div > div.login-form {
        height: 100%;
      }
    `}</style>
                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Header as='h2' color='teal' textAlign='center'>
                            <Image  src='https://weinkulturen.ch/wp-content/uploads/2017/12/cropped-weinkulturen-2.png' />
                            {this.props.translate('login.header')}
                        </Header>
                        <Form size='large' onSubmit={this.handleLogin.bind(this)}>
                            <Segment stacked>
                                <Form.Input
                                    fluid
                                    icon='user'
                                    iconPosition='left'
                                    placeholder={this.props.translate('general.email')}
                                    value={this.state.email}
                                    onChange={this.handleEmailChange.bind(this)}
                                />
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder={this.props.translate('general.password')}
                                    type='password'
                                    value={this.state.password}
                                    onChange={this.handlePasswordChange.bind(this)}
                                />

                                <Button disabled={this.props.isLoading} loading={this.props.isLoading} color='teal' fluid size='large' >Login</Button>
                            </Segment>
                        </Form>
                        <Message>
                            {this.props.translate('login.message')}
                        </Message>
                    </Grid.Column>
                </Grid>
            </div>
        )

    }
}

const mapStateToProps = state => ({
    isLoading: isLoadingUser(state),
    translate: getTranslate(state.localize),
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return({
        login: (username,password) => {dispatch(login(username,password))}
    })
}


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(LoginForm)



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js